export const CERTIFICATE_SUCCESS_TITLE = 'Готово!';

export const CERTIFICATE_SUCCESS_DESCRIPTION = 'Справка будет сформирована и отправлена вам на e-mail';
